module.exports = "/_next/static/images/8f8a8aa500b090f6cc107883e6dc268b-prepayment_boleto.png";